import { render, staticRenderFns } from "./OrdersPageInfoauto.vue?vue&type=template&id=11f7498c&scoped=true"
import script from "./OrdersPageInfoauto.vue?vue&type=script&lang=js"
export * from "./OrdersPageInfoauto.vue?vue&type=script&lang=js"
import style0 from "./OrdersPageInfoauto.vue?vue&type=style&index=0&id=11f7498c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f7498c",
  null
  
)

export default component.exports